(function(){
	class CoolEvents {
		isLocalStorageAvailable = true;
		nonce = '';

		constructor() {
			let test = 'test';

			try {
			    localStorage.setItem(test, test);
			    localStorage.removeItem(test);
			} catch(e) {
				this.isLocalStorageAvailable = false;
			}
		}

		getTmIdentifier() {
			if(!this.isLocalStorageAvailable) {
				return '';
			}

			return localStorage.getItem('tmJwtIdentifier') || '';
		}

		setTmIdentifier(identifier) {
			localStorage.setItem('tmJwtIdentifier', identifier);
		}

		async sendVisitorAction(eventData = false) {
			if(!this.isLocalStorageAvailable) {
				return false;
			}

			const identifier = this.getTmIdentifier();

			let visitorActions = localStorage.getItem('tmVisitorActions');

			if(visitorActions) {
				visitorActions = JSON.parse(visitorActions);
			}
			else {
				visitorActions = [];
			}

			if(!identifier) {
				// Save action for later

				if(eventData) {
					eventData.created_at = new Date().toISOString();

					visitorActions.push(eventData);

					localStorage.setItem('tmVisitorActions', JSON.stringify(visitorActions));
				}
			}
			else {
				if(eventData) {
					eventData.created_at = new Date().toISOString();
					visitorActions.push(eventData);
				}

				if(visitorActions.length) {

					let nonce = await this.waitForNonce();

					let options = {
						method: "POST",
						headers: {
						    "Content-Type": "application/x-www-form-urlencoded",
						},
						body: jQuery.param({
							action: 'visitor_action',
							identifier: identifier,
							eventData: visitorActions,
							nonce: nonce
						})
					};

					const response = await fetch(ajaxurl, options);
					const json = await response.json();

					if(!json.error) {
						localStorage.removeItem('tmVisitorActions');
					}

					//console.log(json);

					return json.error;
				}
			}

			return true;
		}

		async visitorProvidedDetails(name, email, phone) {
			let identifier = this.getTmIdentifier();

			let options = {
				method: "POST",
				body: new URLSearchParams({
					action: 'visitor_provided_details',
				    name: name,
				    email: email,
				    phone: phone,
				    identifier: identifier,
				})
			};

			const response = await fetch(ajaxurl, options);
			const json = await response.json();

			let newIdentifier = json.identifier;

			if(newIdentifier) {
			    this.setTmIdentifier(newIdentifier);

			    zE("messenger", "logoutUser");
			    this.sendVisitorAction();
			}

			return true;
		}

		async trackPageView() {
			const urlToTrack = window.location.href;
			const lastTrackedUrl = localStorage.getItem('coolLastTrackedUrl') || '';

			if(lastTrackedUrl != urlToTrack) {
				let eventData = {
					type: 'page_view',
					description: document.title,
					properties: {
						page: {
							display_name: document.title,
							url: window.location.href,
						}
					}
				};

				let isError = await this.sendVisitorAction(eventData);

				//console.log(isError);

				if(!isError) {
					localStorage.setItem('coolLastTrackedUrl', urlToTrack);
				}
			}
			else {
				//console.log('Not tracking duplicate url');
			}

			return true;
		}

		async createIdentifierForAnonymousUser() {
			let options = {
				method: "POST",
				body: new URLSearchParams({action: 'create_identifier_for_anonymous_user'})
			};

			const response = await fetch(ajaxurl, options);
			const json = await response.json();

			let identifier = json.identifier || '';

			if(identifier) {
				this.setTmIdentifier(identifier);
				this.sendVisitorAction();
			}

			return json.identifier;
		}

		async getChatAuthToken() {
			let token = '';
			let identifier = coolEvents.getTmIdentifier();

			if(!identifier) {
				identifier = await this.createIdentifierForAnonymousUser();
			}

			if(identifier) {
				let options = {
					method: "POST",
					body: new URLSearchParams({
						action: 'visitor_identifier_token',
						identifier: identifier
					})
				};

				const response = await fetch(ajaxurl, options);
				const json = await response.json();

				token = json.data;
			}

			return token;
		}

		async setupVisitorAndTriggerChatOpen() {
			let chatAuthToken = await this.getChatAuthToken();

			if(chatAuthToken) {
				zE("messenger", "loginUser", function(callback){
					callback(chatAuthToken);
				});
			}

			zE("messenger", "open");
			zE("messenger", "show");

			return true;
		}

		async triggerChatOpen() {
			let name = tmVisitorStore.getDetail('name');
			let email = tmVisitorStore.getDetail('email');
			let phone = tmVisitorStore.getDetail('phone');

			zE("messenger", "logoutUser");

			let identifier = this.getTmIdentifier();

			let options = {
				method: "POST",
				body: new URLSearchParams({
					action: 'trigger_chat_open',
					identifier: identifier,
					name: name,
					email: email,
					phone: phone
				})
			};

			const response = await fetch(ajaxurl, options);
			const json = await response.json();

			this.setTmIdentifier(json.userToken);

			const chatAuthToken = json.chatToken;

			if(chatAuthToken) {
				zE("messenger", "loginUser", function(callback){
					callback(chatAuthToken);
				});
			}

			if (phone.length > 0) {
				try {
					zE('messenger:set', 'conversationFields', [{ id: '32804813526541', value: phone}])
				} catch (e) {}
			}

			zE("messenger", "open");
			zE("messenger", "show");

			//console.log(json);

			return true;
		}

		async waitForNonce() {
			return await new Promise(resolve => {
				const interval = setInterval(() => {

					let nonce = tmUtils.getAjaxRequestNonce();

					if(nonce != '') {
						resolve(nonce);
						clearInterval(interval);
					}
				}, 1000);
			});
		}
	}

	jQuery(function(){
		window.coolEvents = new CoolEvents();
		$(window).on("load", function() {
			coolEvents.trackPageView();
		});
	});
})()
